import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { Providers } from './app/Providers';
import { installEventFlusher } from './api/events.api';
import { registerServiceWorker } from './lib/pwa';
import { bootstrapReaderSettings } from './stores/reader.store';
import { applyTheme, useThemeStore, watchSystemTheme } from './stores/theme.store';
import './styles/tailwind.css';

// 首屏前先把主题打到 <html>（index.html 里已有一份更早的内联脚本做同样的事，
// 这里保证在 JS 环境下刷新/切换后状态一致），并订阅系统主题变化。
applyTheme(useThemeStore.getState().mode);
watchSystemTheme();

// 阅读器的字号/行距/行宽存在本地，启动时灌进 CSS 变量：避免长文首屏先用默认字号闪一下。
bootstrapReaderSettings();

// 埋点：页面隐藏时把攒在内存里的事件批量发出去（失败静默，见 api/events.api）。
installEventFlusher();

// PWA：只在生产构建里注册（开发期注册会让热更新与缓存互相打架）。
registerServiceWorker();

const container = document.getElementById('root');
if (!container) {
  throw new Error('未找到 #root 挂载点');
}

createRoot(container).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
);
